import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const masterDataRoutes = [
    {
        key: 'pages.pendidikan',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/pendidikan`,
        component: React.lazy(() => import('views/master-view/jenjang-pendidikan')),
    },
    {
        key: 'pages.pendidikan.add',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/pendidikan/add`,
        component: React.lazy(() => import('views/master-view/jenjang-pendidikan/add')),
    },
    {
        key: 'pages.pendidikan.edit',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/pendidikan/edit/:id`,
        component: React.lazy(() =>import('views/master-view/jenjang-pendidikan/edit')),
    },


    {
        key: 'pages.prodi',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/prodi`,
        component: React.lazy(() => import('views/master-view/program-studi')),
    },
    {
        key: 'pages.prodi.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/prodi/add`,
        component: React.lazy(() => import('views/master-view/program-studi/add')),
    },
    {
        key: 'pages.prodi.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/prodi/edit/:id`,
        component: React.lazy(() =>import('views/master-view/program-studi/edit')),
    },


    {
        key: 'pages.masterJadwal',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/master-jadwal`,
        // component: React.lazy(() => import('views/master-input/master-jadwal'))
        component: React.lazy(() => import('views/master-view/master-jadwal')),
    },
    // {
    //     key: 'pages.masterJadwal.add',
    //     path: `${APP_PREFIX_PATH}/master-data/perkuliahan/master-jadwal/add`,
    //     component: React.lazy(() => import('views/master-input/master-jadwal/add')),
    // },
    // {
    //     key: 'pages.masterJadwal.edit',
    //     path: `${APP_PREFIX_PATH}/master-data/perkuliahan/master-jadwal/edit/:id`,
    //     component: React.lazy(() =>import('views/master-input/master-jadwal/edit')),
    // },
    // {
    //     key: 'pages.masterJadwal.detail',
    //     path: `${APP_PREFIX_PATH}/master-data/perkuliahan/master-jadwal/detail/:id`,
    //     component: React.lazy(() =>import('views/master-input/master-jadwal/detail')),
    // },
    


    {
        key: 'pages.authDikti',
        path: `${APP_PREFIX_PATH}/setting/auth-dikti`,
        component: React.lazy(() => import('views/admin-views/setting/auth-dikti')),
    },
    {
        key: 'pages.authDikti.add',
        path: `${APP_PREFIX_PATH}/setting/auth-dikti/add`,
        component: React.lazy(() => import('views/admin-views/setting/auth-dikti/add')),
    },
    {
        key: 'pages.authDikti.edit',
        path: `${APP_PREFIX_PATH}/setting/auth-dikti/edit/:id`,
        component: React.lazy(() =>import('views/admin-views/setting/auth-dikti/edit')),
    },

    {
        key: 'pages.periode',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/periode`,
        component: React.lazy(() => import('views/master-view/periode')),
    },
    {
        key: 'pages.periode.add',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/periode/add`,
        component: React.lazy(() => import('views/master-view/periode/add')),
    },
    {
        key: 'pages.periode.edit',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/periode/edit/:id`,
        component: React.lazy(() =>import('views/master-view/periode/edit')),
    },
    {
        key: 'pages.user',
        path: `${APP_PREFIX_PATH}/master-data/user`,
        component: React.lazy(() => import('views/master-view/user-management/user-access')),
    },
    {
        key: 'pages.user.add',
        path: `${APP_PREFIX_PATH}/master-data/user/add`,
        component: React.lazy(() => import('views/master-view/user-management/user-access/add')),
    },
    {
        key: 'pages.user.edit',
        path: `${APP_PREFIX_PATH}/master-data/user/edit/:id`,
        component: React.lazy(() => import('views/master-view/user-management/user-access/edit')),
    },
    {
        key: 'pages.jadwal.mahasiswa',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/jadwal-kuliah`,
        component: React.lazy(() => import('views/master-view/jadwal-mahasiswa/')),
    },
    {
        key: 'pages.jadwal.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/jadwal`,
        component: React.lazy(() => import('views/master-view/jadwal-mahasiswa/')),
    },
    {
        key: 'pages.profile.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/profile`,
        component: React.lazy(() => import('views/auth-views/edit-profile')),
    },
    {
        key: 'pages.khs.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/khs`,
        component: React.lazy(() => import('views/mahasiswa-views/mahasiswa-khs/ShowKhsMahasiswa')),
    },
    {
        key: 'pages.pembayaran.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/pembayaran`,
        component: React.lazy(() => import('views/master-view/mahasiswa-pembayaran/ShowPembayaranMahasiswa')),
    },
    {
        key: 'pages.questioner.input.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/kuesioner`,
        component: React.lazy(() => import('views/master-view/kuesioner')),
    },
    {
        key: 'pages.questioner.detail.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/kuesioner/detail/:id`,
        component: React.lazy(() => import('views/master-view/kuesioner/view')),
    },

    /*
    {
        key: 'pages.profile.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/profile/edit-profile`,
        component: React.lazy(() => import('views/master-input/profile-mahasiswa/')),
    },
    {
        key: 'pages.profile.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/profile/change-password`,
        component: React.lazy(() => import('views/master-input/profile-mahasiswa/')),
    },
    {
        key: 'pages.profile.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/profile/billing`,
        component: React.lazy(() => import('views/master-input/profile-mahasiswa/')),
    },*/

    {
        key: 'pages.jadwal.dosen',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/jadwal-dosen`,
        component: React.lazy(() => import('views/admin-views/jadwal-dosen')),
    },

    {
        key: 'pages.administrasi.wisuda',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/wisuda`,
        component: React.lazy(() => import('views/admin-views/administrasi/wisuda')),
    },
    {
        key: 'pages.administrasi.wisuda.detail',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/wisuda/detail`,
        component: React.lazy(() => import('views/admin-views/administrasi/wisuda/detail')),
    },
    {
        key: 'pages.administrasi.wisuda.add',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/wisuda/add`,
        component: React.lazy(() => import('views/admin-views/administrasi/wisuda/add')),
    },
    {
        key: 'pages.administrasi.wisuda.edit',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/wisuda/edit`,
        component: React.lazy(() => import('views/admin-views/administrasi/wisuda/edit')),
    },


    // {
    //     key: 'pages.jadwal.dosen',
    //     path: `${APP_PREFIX_PATH}/dosen/krs`,
    //     component: React.lazy(() => import('views/master-input/approval-krs')),
    // },
    // {
    //     key: 'pages.jadwal.dosen',
    //     path: `${APP_PREFIX_PATH}/dosen/input-nilai`,
    //     component: React.lazy(() => import('views/master-input/dosen-input-nilai/DosenInputNilai')),
    // },
    {
        key: 'pages.bobotPenilaian',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/bobot-penilaian`,
        component: React.lazy(() => import('views/master-view/bobot-penilaian')),
    },
    {
        key: 'pages.bobotPenilaian.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/bobot-penilaian/add`,
        component: React.lazy(() => import('views/master-view/bobot-penilaian/add')),
    },
    {
        key: 'pages.bobotPenilaian.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/bobot-penilaian/edit/:id`,
        component: React.lazy(() =>import('views/master-view/bobot-penilaian/edit')),
    },
    {
        key: 'pages.bobotPenilaian.input',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/bobot-penilaian/detail/:id`,
        component: React.lazy(() =>import('views/master-view/bobot-penilaian/detail')),
    },
    //administrasi


    {
        key: 'cbt',
        path: `${APP_PREFIX_PATH}/master-data/cbt`,
        component: React.lazy(() => import('views/master-view/cbt')),
    },
    {
        key: 'cbt.test',
        path: `${APP_PREFIX_PATH}/master-data/cbt/test`,
        component: React.lazy(() => import('views/master-view/cbt/test')),
    },
    {
        key: 'administrasi.pembayaran.list',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembayaran`,
        component: React.lazy(() => import('views/master-view/payment/list')),
    },
    {
        key: 'administrasi.pembayaran.detail',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembayaran/detail/:id`,
        component: React.lazy(() => import('views/master-view/payment/list/detail')),
    },
    {
        key: 'administrasi.pembayaran.invoice',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembayaran/invoice/:id`,
        component: React.lazy(() => import('views/master-view/payment/list/invoice')),
    },
    {
        key: 'administrasi.pembayaran.add',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembayaran/add`,
        component: React.lazy(() => import('views/master-view/payment/add')),
    },



    {
        key: 'administrasi.pembimbingAkademik',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembimbingAkademik`,
        component: React.lazy(() => import('views/master-view/pembimbing-akademik')),
    },
    {
        key: 'administrasi.pembimbingAkademik.show',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembimbingAkademik/show`,
        component: React.lazy(() => import('views/master-view/pembimbing-akademik/show')),
    },
    {
        key: 'administrasi.pembimbingAkademik.show.add',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembimbingAkademik/show/add`,
        component: React.lazy(() => import('views/master-view/pembimbing-akademik/show/add')),
    },

    {
        key: 'administrasi.pembimbingAkademik.edit',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembimbingAkademik/edit/:id`,
        component: React.lazy(() => import('views/master-view/pembimbing-akademik/edit')),
    },
    // {
    //     key: 'administrasi.pembimbingAkademik.edit',
    //     path: `${APP_PREFIX_PATH}/master-data/administrasi/pembimbingAkademik/edit/:id`,
    //     component: React.lazy(() => import('views/master-view/pembimbing-akademik/edit')),
    // },
    {
        key: 'administrasi.pembimbingAkademik.add',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/pembimbingAkademik/add`,
        component: React.lazy(() => import('views/master-view/pembimbing-akademik/add')),
    },

    //Questioner
    {
        key: 'questioner.input',
        path: `${APP_PREFIX_PATH}/master-data/kuesioner`,
        component: React.lazy(() => import('views/master-view/kuesioner')),
    },
    {
        key: 'questioner.add',
        path: `${APP_PREFIX_PATH}/master-data/kuesioner/add`,
        component: React.lazy(() => import('views/master-view/kuesioner/add')),
    },
    {
        key: 'questioner.detail',
        path: `${APP_PREFIX_PATH}/master-data/kuesioner/detail/:id`,
        component: React.lazy(() => import('views/master-view/kuesioner/view')),
    },
    {
        key: 'questioner.edit',
        path: `${APP_PREFIX_PATH}/master-data/kuesioner/edit/:id`,
        component: React.lazy(() => import('views/master-view/kuesioner/edit')),
    },
    
    
    {
        key: 'administrasi.beasiswa',
        path: `${APP_PREFIX_PATH}/master-data/beasiswa`,
        component: React.lazy(() => import('views/master-view/beasiswa')),
    },
    {
        key: 'administrasi.beasiswa.add',
        path: `${APP_PREFIX_PATH}/master-data/beasiswa/add`,
        component: React.lazy(() => import('views/master-view/beasiswa/add/AddBeasiswa')),
    },
    {
        key: 'administrasi.beasiswa.update',
        path: `${APP_PREFIX_PATH}/master-data/beasiswa/update`,
        component: React.lazy(() => import('views/master-view/beasiswa/update/UpdateBeasiswa')),
    },
    {
        key: 'administrasi.beasiswa.view',
        path: `${APP_PREFIX_PATH}/master-data/beasiswa/view`,
        component: React.lazy(() => import('views/master-view/beasiswa/view/ViewBeasiswa')),
    },






]
